import tw, {css} from 'twin.macro'
import * as React from 'react'
const Row = ({children, ...rest}) => (
  <div css={tw`flex flex-wrap`} {...rest}>
    {children}
  </div>
)
export default Row
